export default "__VITE_ASSET__DbaRDM$n__"